/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface OperationCoverageMapSettingsDto {
  maxValue?: number;
  minValue?: number;
  opacity?: number;
  operationId?: number;
  parameter?: Array<string>;
  polygon?: boolean;
  singleZoneColor?: string;
  unit?: string;
  zones?: number;
}
